var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettleAction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.514,
    r: 12,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.577 12.017h-.98v-.734h1.714l-.734.734zm.186.734h5.985a.368.368 0 0 0 0-.734H9.497l.733-.734h4.518a.361.361 0 0 0 .26-.107.367.367 0 0 0-.26-.627h-3.784l.373-.372a1.07 1.07 0 0 0 .048-1.462h5.189a.934.934 0 0 1 .924.94v5.297c0 .514-.586 1.1-1.1 1.1h-5.76l-2.02 1.303c-.277.212-.683.236-.898-.079a.776.776 0 0 1-.122-.445v-3.713c.365.11.777.02 1.065-.268l.1-.1zm-.436-4.036h-.73v1.834h.73V8.715zm.53 1.834h1.188l.832-.832a.42.42 0 1 0-.594-.594l-1.426 1.426zm.529 3.668v.001h5.362a.37.37 0 0 0 .259-.108.367.367 0 0 0-.26-.626h-5.36v.002a.367.367 0 0 0 0 .73z",
    fill: "#fff",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.877 9.717 8.204 12.39a.42.42 0 0 1-.594 0L4.936 9.717a.42.42 0 0 1 .594-.594l1.957 1.956V6.5h.84v4.58l1.956-1.957a.42.42 0 0 1 .594.594z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 24,
    y1: 0.514,
    x2: -0.598,
    y2: 1.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FCB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DE995"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettleAction);
export default __webpack_public_path__ + "static/media/settleAction.a40c7df4109a51eb06b1406d1d234a20.svg";
export { ForwardRef as ReactComponent };